import type { GTM } from "../../../../../services/gtmEvent/GTMInterfaces";
import { sendGTMEvent } from "../../../../../services/gtmEvents";

export function trackAiAssistantIconClicked(): void {
  const EVENT_NAME = "app-bar-ai-button-click";

  const eventData: GTM.Event = {
    event: EVENT_NAME,
    url: window.location.href,
  };

  sendGTMEvent(eventData);
}
